import React from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';
import { H2, H3, P } from 'common/ui/Text';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

const APIDocsListUsersBlock = () => {
  return (
    <APIDocsBlock>
      <div>
        <H2 className="heading" fontWeight="regular">
          List users
        </H2>
        <P className="textMargin">List the end-users within your workspace.</P>
        <APIDocsTable
          title="Arguments"
          rows={[
            {
              description: 'Your secret API key.',
              heading: 'apiKey',
              subheading: 'string',
            },
            {
              description:
                "The number of entries you'd like to fetch, between 1-100. Defaults to 10.",
              heading: 'limit',
              subheading: 'number (optional)',
            },
            {
              description: (
                <>
                  The <a href="#pagination">cursor</a> from a previous request
                </>
              ),
              heading: 'cursor',
              subheading: 'string (optional)',
            },
          ]}
        />
        <H3 className="subheading" resetStyles>
          Returns
        </H3>
        <P className="textMargin">Returns an array of users.</P>
      </div>
      <div>
        <div className="text">Endpoint</div>
        <Highlight lang="http">https://canny.io/api/v2/users/list</Highlight>
        <APIDocsMethod />
        <APIDocsCurl path="https://canny.io/api/v2/users/list" body={curlSnippet} />
        <div className="text">Example Response</div>
        <Highlight lang="json">{responseSnippet}</Highlight>
      </div>
    </APIDocsBlock>
  );
};

export default APIDocsListUsersBlock;

const curlSnippet = `\\
    -d apiKey=YOUR_API_KEY \\
    -d limit=100 \\
    -d cursor=NTUzYzNlZjhiOGNkY2QxNTAxYmExMjNhXzIwMjUtMDItMDRUMTY6NDA6MDcuNTQxWl8x`;

const responseSnippet = `
{
  "hasNextPage": true,
  "cursor": "NTUzYzNlZjhiOGNkY2QxNTAxYmExMjNhXzIwMjUtMDItMDRUMTY6NDA6MDcuNTQxWl8x",
  "users": [{
    "id": "553c3ef8b8cdcd1501ba123a",
    "alias": "Green Fish",
    "avatarURL": "https://canny.io/images/a3db0133d1e7d9122832b67b2c4caaaa.jpg",
    "created": "${new Date().toISOString()}",
    "customFields": {
      "field1": "value1",
      "field2": "value2"
    },
    "email": "test@test.test",
    "isAdmin": false,
    "lastActivity": "${new Date().toISOString()}",
    "name": "Sally Doe",
    "url": "https://your-company.canny.io/admin/users/sally-doe",
    "userID": "1234"
  }]
}`;
